var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "js-main" }, [
    _c(
      "section",
      { ref: "appMain" },
      [
        _c(
          "keep-alive",
          { attrs: { include: _vm.cachedViews } },
          [_c("router-view", { key: _vm.key, staticClass: "pc" })],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [{ name: "drag", rawName: "v-drag" }],
        staticClass: "js-ball",
        attrs: { id: "dragbtn" },
      },
      [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.ballShow,
                expression: "ballShow",
              },
            ],
            staticClass: "floatBall",
            on: { click: _vm.handelDetail },
          },
          [
            _c("div", { staticClass: "num" }, [_vm._v(_vm._s(_vm.allCount))]),
            _vm._v(" "),
            _c("div", { staticClass: "text" }, [_vm._v("全部告警")]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.detailShow,
                expression: "detailShow",
              },
            ],
            staticClass: "floatAllBall",
          },
          [
            _c(
              "div",
              {
                staticClass: "detailBall",
                on: { click: _vm.handelDetailShow },
              },
              [_c("div", { staticClass: "text" }, [_vm._v("查看详情")])]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "serious" }, [
              _c(
                "div",
                { staticClass: "num", staticStyle: { color: "#e81e2d" } },
                [_vm._v(_vm._s(_vm.serious))]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "all-text", staticStyle: { color: "#e81e2d" } },
                [_vm._v("紧急")]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "important" }, [
              _c(
                "div",
                { staticClass: "num", staticStyle: { color: "#f47401" } },
                [_vm._v(_vm._s(_vm.important))]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "all-text", staticStyle: { color: "#f47401" } },
                [_vm._v("重要")]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "common" }, [
              _c(
                "div",
                { staticClass: "num", staticStyle: { color: "#006dff" } },
                [_vm._v(_vm._s(_vm.common))]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "all-text", staticStyle: { color: "#006dff" } },
                [_vm._v("一般")]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "notice" }, [
              _c(
                "div",
                { staticClass: "num", staticStyle: { color: "#07c000" } },
                [_vm._v(_vm._s(_vm.notice))]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "all-text", staticStyle: { color: "#07c000" } },
                [_vm._v("提示")]
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.ballShow,
                expression: "!ballShow",
              },
            ],
            staticClass: "arrow",
            attrs: { id: "arrow" },
            on: { click: _vm.handelShow },
          },
          [
            _c("img", {
              attrs: {
                src: require("@/assets/js_img/arrow-left.png"),
                alt: "",
              },
            }),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.ballShow,
                expression: "ballShow",
              },
            ],
            staticClass: "arrow",
            on: { click: _vm.handelShow },
          },
          [
            _c("img", {
              attrs: {
                src: require("@/assets/js_img/arrow-right.png"),
                alt: "",
              },
            }),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "dialog" },
      [
        _c(
          "el-dialog",
          {
            attrs: {
              visible: _vm.dialogFormVisible,
              width: "40%",
              "close-on-click-modal": false,
              "close-on-press-escape": false,
              "show-close": false,
            },
            on: {
              "update:visible": function ($event) {
                _vm.dialogFormVisible = $event
              },
            },
          },
          [
            _c(
              "div",
              {
                staticClass: "header",
                attrs: { slot: "title" },
                slot: "title",
              },
              [
                _c("div", { staticClass: "header-left" }, [
                  _c("div", { staticClass: "title" }, [_vm._v("告警列表")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "skip", on: { click: _vm.handelSkip } },
                    [_vm._v("进入告警中心")]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "header-right" }, [
                  _c(
                    "div",
                    { staticClass: "refresh", on: { click: _vm.handelClose } },
                    [_c("i", { staticClass: "el-icon-close" })]
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "el-row",
              [
                _c("el-col", { attrs: { span: 5 } }, [
                  _c("div", { staticClass: "alarm" }, [
                    _c(
                      "div",
                      { staticClass: "card", on: { click: _vm.handleAll } },
                      [
                        _c("div", { staticClass: "text" }, [
                          _vm._v("当前告警"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "num",
                            staticStyle: { color: "#e81e2d" },
                          },
                          [_vm._v(_vm._s(_vm.allCount))]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "card",
                        on: {
                          click: function ($event) {
                            return _vm.handleLevel("3")
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "text" }, [
                          _vm._v("紧急告警"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "num",
                            staticStyle: { color: "#e81e2d" },
                          },
                          [_vm._v(_vm._s(_vm.serious))]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "card",
                        on: {
                          click: function ($event) {
                            return _vm.handleLevel("2")
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "text" }, [
                          _vm._v("重要告警"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "num",
                            staticStyle: { color: "#f47401" },
                          },
                          [_vm._v(_vm._s(_vm.important))]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "card",
                        on: {
                          click: function ($event) {
                            return _vm.handleLevel("1")
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "text" }, [
                          _vm._v("一般告警"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "num",
                            staticStyle: { color: "#006dff" },
                          },
                          [_vm._v(_vm._s(_vm.common))]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "card",
                        on: {
                          click: function ($event) {
                            return _vm.handleLevel("0")
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "text" }, [
                          _vm._v("提示告警"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "num",
                            staticStyle: { color: "#07c000" },
                          },
                          [_vm._v(_vm._s(_vm.notice))]
                        ),
                      ]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("el-col", { attrs: { span: 19 } }, [
                  _c("div", { staticClass: "content" }, [
                    _c(
                      "div",
                      { staticClass: "main" },
                      _vm._l(_vm.alarmList, function (item, index) {
                        return _c("div", { key: index, staticClass: "cell" }, [
                          _c(
                            "span",
                            {
                              staticStyle: { width: "20%" },
                              style:
                                item.nwreWarnLevel === "0"
                                  ? "color: #07c000"
                                  : item.nwreWarnLevel === "1"
                                  ? "color: #006dff"
                                  : item.nwreWarnLevel === "2"
                                  ? "color: #f47401"
                                  : item.nwreWarnLevel === "3"
                                  ? "color: #e81e2d"
                                  : "",
                            },
                            [
                              _vm._v(
                                "【" +
                                  _vm._s(
                                    _vm.swruWarnLevelName(item.nwreWarnLevel)
                                  ) +
                                  "】"
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticStyle: { margin: "0 15px", width: "40%" } },
                            [_vm._v(_vm._s(item.nwruAddressName))]
                          ),
                          _vm._v(" "),
                          _c("span", { staticStyle: { width: "40%" } }, [
                            _vm._v(_vm._s(_vm.getTime(item.createdOn))),
                          ]),
                        ])
                      }),
                      0
                    ),
                  ]),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }